import * as React from 'react';

import { UitkMenuList } from 'uitk-react-menu';

interface SearchFormOptionsListProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  items: any;
  closeMenu?: () => void;
}

export class SearchFormOptionsList extends React.Component<SearchFormOptionsListProps> {
  constructor(props) {
    super(props);
  }

  public render() {
    const menuCloseAction = this.props.closeMenu;

    const itemsWithMenuCloseAction = this.props.items.map(item => {
      const currentOnClickRef = item.onClick;

      item.onClick = evt => {
        currentOnClickRef(evt);
        menuCloseAction();
      };

      return item;
    });

    return <UitkMenuList items={itemsWithMenuCloseAction} />;
  }
}
